/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const ResolvedOfferVariable = zod.unknown().and(
  zod.object({
    scope: zod.enum(["HEADER", "BLOCK", "FOOTER"]),
    chapterId: zod.uuid().optional(),
    blockId: zod.uuid().optional(),
    name: zod.string(),
    value: zod.string(),
  }),
);

export type ResolvedOfferVariable = zod.input<typeof ResolvedOfferVariable>;
export type ResolvedOfferVariableOutput = zod.output<typeof ResolvedOfferVariable>;
